import { isTimeRegistrationNoteRequired } from '../../cache/TimeRegistrationSettingsUtil';
export function isTimeRegistrationNoteInvalid(notes) {
    return isTimeRegistrationNoteRequired() && (!notes || notes.trim().length <= 0);
}
